import SwipeListener from "swipe-listener";
import EventEmitter from "events";

export default class Swiper extends EventEmitter {
    constructor(container) {
        super();
        this.swipeContainer = container;
        this._swipeListener = SwipeListener(this.swipeContainer, {
            lockAxis: true,
            mouse: false,
        });
        this._swipeEffect = document.querySelector(".swipeEffect");
    }

    bind() {
        this.swipeContainer.addEventListener("swipe", (e) => {
            if (this.isExceptionElement(e.detail.target)) {
                return;
            }
            let directions = e.detail.directions;
            let abs = Math.max(Math.abs(e.detail.x[0] - e.detail.x[1]), Math.abs(e.detail.y[0] - e.detail.y[1]));

            if (abs > 100) {
                this.emit("SWIPED", directions);
            }
        });

        if (!this._swipeEffect) {
            return;
        }
        this.swipeContainer.addEventListener("swiping", (e) => {
            if (this.isExceptionElement(e.detail.target)) {
                return;
            }
            let diff = e.detail.x[0] - e.detail.x[1];
            let abs = Math.abs(diff);

            if (abs > 75) {
                if (diff < 0) {
                    // previous
                    this._swipeEffect.classList.remove("fromRight");
                    this._swipeEffect.classList.add("fromLeft");
                    this._swipeEffect.style.transform = `translateX(-${Math.max(250 - abs, 0)}px)`;
                } else {
                    // next
                    this._swipeEffect.classList.remove("fromLeft");
                    this._swipeEffect.classList.add("fromRight");
                    this._swipeEffect.style.transform = `translateX(${Math.max(250 - abs, 0)}px)`;
                }
            }
        });

        this.swipeContainer.addEventListener("swiperelease", (e) => {
            if (this.isExceptionElement(e.detail.target)) {
                return;
            }
            this._swipeEffect.classList.remove("fromLeft");
            this._swipeEffect.classList.remove("fromRight");
        });
    }

    unbind() {
        this.swipeContainer.off();
    }

    disableEffect(first, last) {
        if (!this._swipeEffect) {
            return;
        }
        first ? this._swipeEffect.classList.add("first") : this._swipeEffect.classList.remove("first");
        last ? this._swipeEffect.classList.add("last") : this._swipeEffect.classList.remove("last");
    }

    isExceptionElement(element) {
        if (!element.closest) {
            return false;
        }
        const maglrElement = element.closest(".element");
        return maglrElement?.classList?.contains("slideshow") || element.closest(".do-not-swipe");
    }
}
